<template>
  <span @click.prevent="onCopy" :class="copyClass">
    <i class="material-icons">{{ icon }}</i>
    <textarea class="_copy__textarea" ref="textarea" :value="url"></textarea>
    <span class="_copy__success" :class="{ _on: isLinkCopied }">Link Copied</span>
  </span>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      default: () => 'link'
    }
  },
  data: () => ({
    urlModel: '',
    timeoutId: null,
    isLinkCopied: false,
  }),
  computed: {
    url() {
      return `${window.location.origin}/#${this.$route.path}#${this.id}`;
    },
    //set class based on user type
    copyClass() {
      if(this.$Session.isAdminGroupMember) {
        return '_copy';
      } else {
        return '_copy _fixCopy';
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.scrollToElement();
    }, 1500);
  },
  methods: {
    onCopy() {
      this.selectText(),
      this.copyText();
    },
    selectText() {
      const textarea = this.$refs.textarea;
      textarea.focus();
      textarea.select();
    },
    copyText() {
      try {
        this.isLinkCopied = document.execCommand('copy');
        if (this.isLinkCopied) {
          this.showTooltip();
        }
      } catch (err) {
        console.log(err);
      }
    },
    showTooltip() {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.isLinkCopied = false;
      }, 1000);
    },
    scrollToElement() {
      let parentEle = document.getElementById('sidePanelBody');
      const targetEle = document.getElementById(this.id);

      if (!parentEle || !targetEle) {
        return
      }
      
      if (targetEle && window.location.href === this.url) {
        /**
         * ATLAS-1142: <Service-Sidepanel><Deeplink> Deeplink is not working, 
         * Upon clicking it, it is not auto-scrolling to the proper Reply message.
         * @see https://zeamster.atlassian.net/browse/ATLAS-1142
         * Don't scroll if it is the last link in hisotry
         */
        if (this.url === this.$Session.deepLinkHistory[0]) {
          return;
        }
        this.$Session.deepLinkHistory.unshift(this.url);
        
        // parentEle.scrollTo({
        //   top: this.getOffset(targetEle),
        //   left: 0,
        //   // behavior: 'smooth'
        // });
        
        console.log('Scrolling to target element from DeepLink.vue')
        targetEle.scrollIntoView(true)
      }
    },
    getOffset(targetEle) {
      if (!targetEle.getBoundingClientRect) {
        return 0;
      }
      const headerEle = document.querySelector('.md-toolbar');
      let offset = targetEle.getBoundingClientRect().top
      if (headerEle) {
        offset -= headerEle.getBoundingClientRect().height;
      }
      return offset;
    }
  },
}
</script>

<style lang="scss" scoped>
  ._copy {
    display: block;
    position: relative;
    margin: 0.5rem 1rem 0 auto;
    cursor: pointer;
  }
  ._copy__textarea {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    clip: rect(1px, 1px, 1px, 1px);
    text-indent: -999em;
  }
  ._copy__success {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 100%;
    left: 50%;
    width: 80px;
    margin-bottom: 10px;
    padding: 5px;
    background-color: rgba(#000, 0.75);
    border-radius: 2px;
    color: #fff;
    font-size: 11px;
    line-height: 1;
    text-align: center;
    transform: translateX(-50%) scale(0.5);
    transition: all 0.15s;
    &._on {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) scale(1);
    }
    &::after {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -6px;
      border: 6px solid transparent;
      border-bottom-color: rgba(#000, 0.75);
    }
  }
</style>
